// extracted by mini-css-extract-plugin
export var chip = "_en-0";
export var filterDropdown = "_en-5";
export var filterItem = "_en-6";
export var icon = "_en-1";
export var removeButton = "_en-3";
export var removeIcon = "_en-4";
export var separator = "_en-2";